import request from "./clientsApi";
import { API_ROUTES } from "../config/baseURL";

const homologacionApi = {
    getAll: () =>
        request(API_ROUTES.homologacionValores, { method: "GET" }).then((r) => r.json()),

    save: (data) =>
        request(API_ROUTES.homologacionValores, {
            method: data.id ? "PUT" : "POST",
            body: JSON.stringify(data),
        }).then((r) => r.json()),

    delete: (id) =>
        request(API_ROUTES.homologacionValoresEliminar, {
            method: "POST",
            body: JSON.stringify({ id }),
        }).then((r) => r.json()),
};

export default homologacionApi;
